module.exports = __webpack_public_path__ + "img/video.f1ccbbdd.svg";